import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen } from 'lucide-react';
import { X, Check } from 'lucide-react';
export function PainPoints() {
  return <section className="py-20 md:py-32 px-4 bg-dark-card/30" data-id="element-179">
      <div className="max-w-4xl mx-auto" data-id="element-180">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-181">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gold/10 mb-6" data-id="element-182">
            <BookOpen className="w-8 h-8 text-gold" data-id="element-183" />
          </div>
          <h2 className="text-3xl md:text-5xl font-heading font-bold mb-8 text-white leading-tight" data-id="element-184">
            ¿Qué vas a descubrir con Vikingos Legendarios?
          </h2>
        </motion.div>

        <div className="bg-dark border border-dark-border p-8 md:p-12 rounded-2xl relative overflow-hidden" data-id="element-185">
          <div className="absolute top-0 right-0 w-64 h-64 bg-gold/5 rounded-bl-full -mr-32 -mt-32" data-id="element-186" />

          <div className="relative z-10 space-y-6 text-lg md:text-xl text-gray-300 leading-relaxed" data-id="element-187">
            <p data-id="element-188">
              Durante siglos, los vikingos fueron mucho más que guerreros
              temidos. Fueron navegantes extraordinarios, exploradores,
              comerciantes y protagonistas de una de las culturas más
              fascinantes de la historia.
            </p>
            <p data-id="element-189">
              Esta colección reúne información cuidadosamente organizada para
              ayudarte a comprender sus orígenes, su expansión por Europa, sus
              dioses, sus leyendas, sus creencias y el legado que dejaron en el
              mundo moderno.
            </p>
          </div>
        </div>
      </div>
    </section>;
}